import { render, staticRenderFns } from "./table-buttons.vue?vue&type=template&id=6a6545a1"
import script from "./table-buttons.vue?vue&type=script&lang=ts"
export * from "./table-buttons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6545a1')) {
      api.createRecord('6a6545a1', component.options)
    } else {
      api.reload('6a6545a1', component.options)
    }
    module.hot.accept("./table-buttons.vue?vue&type=template&id=6a6545a1", function () {
      api.rerender('6a6545a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-buttons.vue"
export default component.exports